export const sysInfoMap = {
  sourceType: {
    0: "系统",
    1: "玩家"
  },
  type: {
    0: "default",
    1: "warn",
    2: "win",
    3: "tip",
    4: "battle",
    5: "player"
  }
};

export class SysInfo {
  constructor(
    content = "",
    type = 0,
    equip: any[] | null = null,
    source = 0,
    name = ""
  ) {
    this.content = content;
    this.equip = equip;
    this.type = type;
    this.source = source;
    this.name = name;
  }
  type = 0;
  source = 0;
  timestamp = new Date();
  content = "";
  equip: any[] | null = null;
  name = "";
}
